async function fetchCart(type, selectedItems) {

    const items = Object.values(selectedItems).map((product) => ({
        id: product.id.split('/').pop(),
        quantity: product.quantity,
    }));

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
    }).then(() => {
        if (type) {
            location.href = type;
        }
        else {
            openMiniCart();
            let itemsCart = document.querySelectorAll('#cores_grade .variant .quantity-selector .variant-quantity');
            if (itemsCart) {
                itemsCart.forEach(function (input) {
                    input.value = 0;
                });
            }

        }
    });
}